import BlogLoader from '@frontend/components/blog/BlogLoader'
import { generateUuidList } from '@frontend/libs/utils'

export default function BlogListLoader() {
  return (
    <>
      {generateUuidList(4).map((item) => (
        <BlogLoader key={item} />
      ))}
    </>
  )
}
